import { render, staticRenderFns } from "./SidebarEditor.vue?vue&type=template&id=a2b24880&scoped=true"
import script from "./SidebarEditor.vue?vue&type=script&lang=js"
export * from "./SidebarEditor.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditor.vue?vue&type=style&index=0&id=a2b24880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b24880",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIEditorTextEditor: require('/opt/atlassian/pipelines/agent/build/components/UI/Editor/TextEditor.vue').default})
